module.exports = __webpack_public_path__ + "static/prestashop_monei-33e84f2ec1401db9161e22810e3de95c.svg";